<template>
    <v-dialog v-model="dlg" width="90%" scrollable persistent>
    <v-card class="px-4">
      <v-card-title class="px-0">
        <v-col cols="12" class="px-0 text-right">
            <v-btn icon color="primary" @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-col>
        <v-col cols="12" class="pt--12 px-0 ma-0 text-center">
            <h1>Edição em massa de protocolos</h1>
        </v-col>
        <v-row class="px-3 py-0 ma-0">
          <!-- <v-alert dense outlined text type="warning" icon="fa fa-exclamation-triangle" width="60%"
                   >
           <b>Existem lotes com crítica!</b><br>
           <small>Ignore a crítica ou exclua-os antes de concluir o cronograma. -->
            <v-switch
                v-if="exibeIgnoraCritica && dataToSave.length && !disableSaveButton && data.grupo_economico == 46" 
                x-small
                v-model="critica_ignorada"
                :label="'Ignorar crítica automaticamente'"
                color="primary"
                class="ma-0"
                height="30px"
                ></v-switch>
          <!--</small> 
          </v-alert> -->
          <v-spacer></v-spacer>
            <v-btn text class="mx-3" small height="30px" color="primary" depressed outlined @click="dialogUnico=true">
              <v-icon x-small class="pr-2">fa-pencil-alt</v-icon>Protocolo único
            </v-btn>
            <v-btn :disabled="!dataToSave.length || disableSaveButton" color="primary" height="30px" small depressed @click="saveProtocolosConfirm()"
              > Salvar protocolos
            </v-btn>
        </v-row>
      </v-card-title>

      <v-card-text class="py-5 px-3">
        <ProtocoloList 
          :headers="headers"
          :disableSaveButton="(bool)=>disableSaveButton = bool " 
          :list="protocoloList" 
          :status="status"
          :formRules="formRules"
          :armazenaItem="armazenaItem"
          :dataToSave="dataToSave"
          :updateDataToSave="(item) => updateDataToSave(item)"
          :formatDate="(date) => formatDate(date)"
          :parseDate="(date) => parseDate(date)"
          :desfazerAlteracoes="(item) => desfazerAlteracoes(item)"
          :historico="(item) => historico(item)"
          :validRules="validRules"
        />
      </v-card-text>

      <v-card-actions class="py-3 px-0">
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-pagination
              class="no-box-shadow"
              v-model="pagination.offset"
              :length="pagination.total_pages"
              @input="getList(pagination.offset)"
            ></v-pagination>
          </v-col>
          <v-col cols="12" class="text-center pt-1 px-0">
            <v-btn color="primary" outlined height="30px" small depressed @click="closeDialog"
              >Fechar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <ProtocoloUnicoDlg 
      :dialog="dialogUnico"
      :exibeIgnoraCritica = "exibeIgnoraCritica && data.grupo_economico == 46"
      :close="() => dialogUnico = false" 
      :formRules="formRules" 
      :formData="formData" 
      :info="data" 
      :status="status"
      :formatDate="(date) => formatDate(date)"
      :parseDate="(date) => parseDate(date)"
      :updateCriticaIgnorada = "(val) => updateCriticaIgnorada(val)"
      :save="() => saveProtocolosConfirm(formData)"
    />
    <ProtocoloHistoricoDlg
      :dialog="dialogHistorico" 
      :close="() => dialogHistorico = false" 
      :list="historicoList"
      :statusList="statusList"
      :headers="historicoHeaders"
    />
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import ProtocoloList from '@/components/faturamento/dados_cronograma/ProtocoloList.vue'
import ProtocoloUnicoDlg from '@/components/faturamento/dados_cronograma/ProtocoloUnicoDlg.vue'
import ProtocoloHistoricoDlg from '@/components/faturamento/dados_cronograma/ProtocoloHistoricoDlg.vue'
export default {
  components: {
    ProtocoloList,
    ProtocoloUnicoDlg,
    ProtocoloHistoricoDlg
  },
  props: {
    close: Function,
    complementar: Boolean,
    data: Object,
    dialog: Boolean,
    lotesIds: Array
  },
  data() {
    return {
      dlg: false,
      disableSaveButton: true,
      exibeControleValidacao: true,
      headers: [],
      //   { text: "Arquivo", align: "start", value: "arq_nome", sortable: false},
      //   { text: "Núm. Lote", align: "center", value: "arq_numero_lote", sortable: false },
      //   { text: "Valor. Calc (R$)", align: "end", value: "arq_vl_calculado", sortable: false  },
      //   { text: "Núm. Protocolo", value: "env_op_protocolo", sortable: false },
      //   { text: "Data envio", value: "env_op_dt_protocolo", sortable: false },
      //   { text: "Retorno da operadora", value: "env_op_status_protocolo", sortable: false },
      //   { text: "Crítica", value: "erro_protocolo", sortable: false },
      //   { text: "", value: "desfazer", sortable: false }
      // ],
      list: [],
      protocoloList: [],
      pagination: {
        offset: 1,
        total_pages: 1,
        limit: 10
      },
      validRules: false,
      status:[
        // {id: "0" , descricao: 'Aguardando retorno'},
        {id: "3" , descricao: 'Aceito'},
        // {id: "1" , descricao: 'Aceito parcialmente'},
        {id: "4" , descricao: 'Rejeitado'}
      ],
      dialogHistorico: false,
      historicoHeaders: [
        { text: "Atualizado em:", align: "left", value: "dt_alteracao", sortable: false },
        { text: "Protocolo", align: "start", value: "numero", sortable: false },
        { text: "Data protocolo", value: "dt_protocolo", sortable: false },
        { text: "Retorno da oper.", value: "status", sortable: false }
      ],
      historicoList: [],
      statusList: {
        0: 'Aguardando retorno',
        3: 'Aceito',
        1: 'Aceito parcialmente',
        4: 'Rejeitado'
      },
      critica_ignorada: false,
      dialogUnico: false,
      formValid: true,
      formData: {
        env_op_protocolo: null,
        env_op_dt_protocolo: null,
        env_op_status_protocolo: null,
        erro_protocolo: null,
      },
      dataToSave: []
    }
  },
  watch: {
    dialog(bool) {
      this.critica_ignorada = false;
      if (bool) {
        this.getList(1)
        this.dlg = true
      } else {
        this.dataToSave = []
        this.dlg = false
        this.exibeControleValidacao = true
      }
    },
    list(arr) {
      this.protocoloList = arr.map(el=> ({...el}))
      this.protocoloList.forEach(el => {
        el.dateFormatted = el.env_op_dt_protocolo == '0001-01-01T00:00:00' ?null :this.formatDate(el.env_op_dt_protocolo)
        el.env_op_dt_protocolo = el.env_op_dt_protocolo == '0001-01-01T00:00:00' ? null :el.env_op_dt_protocolo;
        el.env_op_status_protocolo = el.env_op_status_protocolo=='1' ?'4' : el.env_op_status_protocolo;
        el.dt = false
        //el.erro_protocolo = el.env_op_status_protocolo == '4' || el.proc_trd_tem_erro ? this.deserialize(el.erro_protocolo) : null
        el.novo_protocolo = el.env_op_protocolo == null? true : false
        el.erro_cadastro = false
      })

      let listaEdicao = this.dataToSave
      if (listaEdicao.length){
        this.protocoloList.map( item => {
          let itemEditado = listaEdicao.find(el=> el.id == item.id)
          if(itemEditado!=undefined){
            return Object.assign(item, itemEditado)
          }
          return item
        })
      }
    },
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
    }),
    exibeIgnoraCritica() {
      if(this.data.grupo_economico != 46)
        return false

      let erroValidacao = this.protocoloList.filter(el=> el.proc_trd_tem_erro == true && el.critica_ignorada == false)
      return erroValidacao && this.data && this.data.config && this.data.config.FAT_ACEITA_XML_INVALIDO
    }
  },
  mounted(){
    this.headers = this.complementar?
        [
          { text: "Arquivo", align: "start", value: "arq_nome", sortable: false},
          { text: "Núm. Lote", align: "center", value: "arq_numero_lote", sortable: false },
          { text: "Valor. Calc (R$)", align: "end", value: "arq_vl_calculado", sortable: false  },
          { text: "Núm. Protocolo", value: "env_op_protocolo", sortable: false },
          { text: "Data envio", value: "env_op_dt_protocolo", sortable: false },
          { text: "", value: "desfazer", sortable: false }
        ]:
        [
        { text: "Arquivo", align: "start", value: "arq_nome", sortable: false},
        { text: "Núm. Lote", align: "center", value: "arq_numero_lote", sortable: false },
        { text: "Valor. Calc (R$)", align: "end", value: "arq_vl_calculado", sortable: false  },
        { text: "Núm. Protocolo", value: "env_op_protocolo", sortable: false },
        { text: "Data envio", value: "env_op_dt_protocolo", sortable: false },
        { text: "Retorno da operadora", value: "env_op_status_protocolo", sortable: false },
        { text: "Crítica", value: "erro_protocolo", sortable: false },
        { text: "", value: "desfazer", sortable: false }
      ]
  },
  methods: {
    formatDate (date) {
      if (!date) return null
        const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
        const [day, month, year] = date.split('/')
      return `${year}-${month}-${day}`
    },
    deserialize(json) {
      let opts = JSON.parse(json)
      opts = opts && opts.criticas ? opts.criticas : ''
      opts = opts && opts.erros ?opts.erros : null
      opts = opts && opts.erro.length ? opts.erro[0].descricao :null
      return opts
    },
    armazenaItem(item, campo) {
      // if(this.complementar){
      //   item.env_op_status_protocolo = 3;
      // }
      let ind = this.protocoloList.findIndex(el=> el.id == item.id)
      if(ind>-1 && this.protocoloList[ind][campo] != this.list[ind][campo]) {
        this.updateDataToSave(item)
      }
    },
    updateCriticaIgnorada(val){
        this.critica_ignorada =  val;
    },
    updateDataToSave(item){
      let index = this.dataToSave.findIndex(el=>el.id == item.id)
      // if(this.complementar){
      //   item.env_op_status_protocolo = 3;
      // }
      if(index > -1){
        this.dataToSave[index] = {...item}
      } else {
        this.dataToSave.push({...item})
      }
    },
    desfazerAlteracoes(item){
      let parametros = Object.keys(item)
      let index = this.list.findIndex(el=> el.id == item.id)
      let itemOriginal = this.list[index]
      itemOriginal.erro_protocolo = (itemOriginal.env_op_status_protocolo == '1' || itemOriginal.env_op_status_protocolo == '4') ?this.deserialize(itemOriginal.erro_protocolo) :null
      parametros.forEach(param =>  item[param] = itemOriginal[param]=='1' ?'4' :itemOriginal[param] == '0001-01-01T00:00:00' ?null :itemOriginal[param] ?itemOriginal[param] :null)
      item.dateFormatted = this.formatDate(itemOriginal.env_op_dt_protocolo == '0001-01-01T00:00:00' ?null :itemOriginal.env_op_dt_protocolo)
      this.dataToSave = this.dataToSave.filter(el => el.id != item.id)
    },
    getList(page) {

      if (this.lotesIds.length) {
        this.pagination.offset = page ?page :1
        let payload = {grupo_economico: this.data.grupo_economico, cronograma_id: this.data.id, lotes_ids: this.lotesIds, complementar: this.complementar, ...this.pagination}
        let obj = {query: [{Modulo: "Faturamento", Acao: "getprotocoloemmassa", Payload: payload }]};
        this.$store.dispatch("request/doRequest", obj).then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader")
            return;
          }
          this.list = response.dados
          this.pagination.total_pages = response.total_pages
          this.pagination.offset = response.current_page
          this.dlg = true
        });
      } 
    },
    historico(item) {
      this.dialogHistorico = true
      this.historicoList = item.historico
    },
    saveProtocolosConfirm(formData) {
      let validRules = this.dataToSave.filter(el => el.env_op_protocolo == null || el.env_op_protocolo == '' || el.env_op_dt_protocolo == null || el.env_op_status_protocolo == null || (el.env_op_status_protocolo == '4' && (el.erro_protocolo == null ||  el.erro_protocolo == ''))) 
      if(this.complementar)
        validRules = this.dataToSave.filter(el => el.env_op_protocolo == null || el.env_op_protocolo == '' || el.env_op_dt_protocolo == null || el.env_op_status_protocolo == null)
      if (validRules.length) {
        let paramModal = {
          type: "error",
          title: "Campo obrigatório!",
          message: "Preencha todos os campos obrigatório para prosseguir.",
          callback: () => {
            this.validRules = true
          },
          btConfirm: { name: "Ok", show: true, color: "error"},
          btCancel: { name: 'Cancelar', show: false }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } 
      else if(!this.disableSaveButton 
      && this.exibeIgnoraCritica && this.dataToSave.length 
      && this.data.grupo_economico == 46 && this.exibeControleValidacao) 
      {
        this.exibeControleValidacao = false;
        let paramModal = {
              type: "warning",
              title: "Existem lotes com crítica!",
              message: "Ignore a crítica ou exclua-os antes de concluir o cronograma.<br><br><b>Deseja ignorar as criticas automaticamente?</b>",
              callback: () => {
                this.critica_ignorada = true;
                this.saveProtocolos(formData);
              },
              btConfirm: { name: 'Sim', show: true },
              btCancel: { name: 'Não', show: true }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
            
      }
      else {
        this.saveProtocolos(formData)
      }
      
    },
    saveProtocolos(formData) {
        this.validRules = false
        if (this.dataToSave.length && this.complementar) {
          this.dataToSave.forEach(item => { item.env_op_status_protocolo = '3'; item.erro_protocolo = null })
        } else if(this.dataToSave.length){
          this.dataToSave.forEach(item => { item.erro_protocolo = item.env_op_status_protocolo == '4' ?item.erro_protocolo : null })
        }
        let opt = {grupo_economico: this.data.grupo_economico, prestador_id: this.data.prestador_id, operadora_ans_id: this.data.operadora_ans_id, cronograma_id: this.data.id}
        let payload = formData ?{protocolo_unico: true, ...opt, lote_ids: this.lotesIds, ...formData, critica_ignorada: this.critica_ignorada} :{protocolo_unico: false, ...opt, objetos: this.dataToSave, critica_ignorada: this.critica_ignorada}
        let obj = {query: [{Modulo: "Faturamento", Acao: "updateprotocoloemmassa", Payload: payload}]};
        this.$store.dispatch("request/doRequest", obj).then((response) => {
          if (!response || response.isAxiosError || response.erros.length) {
            this.$store.commit("hideLoader")
            return;
          }
          let idsErros = []
          if (response.ids_nao_cadastrados) {
            idsErros = response.ids_nao_cadastrados
            let paramModal = {
              type: "warning",
              title: "Atenção!",
              message: response.mensagem,
              callback: () => {
                if (formData) {
                  this.dataToSave = []
                  this.dialogUnico = false
                }
                this.dataToSave = this.dataToSave.filter(el => el.id == idsErros.find(id => id == el.id))
                this.dataToSave.forEach(item => {
                  item.erro_cadastro = true
                })
                setTimeout(() => {this.getList(1)}, 20)
              },
              btConfirm: { name: "Ok", show: true, color: "warning"},
              btCancel: { name: 'Cancelar', show: false }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          } else {
            let paramModal = {
              type: "success",
              title: "Sucesso!",
              message: response.mensagem,
              callback: () => {
                this.dataToSave = []
                this.getList(1)
                formData ?this.dialogUnico = false :null
              },
              btConfirm: { name: "Ok", show: true, },
              btCancel: { name: 'Cancelar', show: false }
            }
            this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
          }
        });
      },
    closeDialog() {
      this.validRules = false
      if (this.dataToSave.length) {
        let paramModal = {
          type: "warning",
          title: "Há protocolos editados não salvos",
          message: "Ao sair serão perdidas todas as alterações. <br> Deseja prosseguir?",
          callback: () => { this.close() },
          btConfirm: { name: "sim", show: true, color: "warning"},
          btCancel: { name: 'não', show: true, color: "warning" }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        this.close()
      }
    }
  }
}
</script>

<style lang="scss">
.button-histor:focus {
  outline: none;
}
.card-title-form-guia {
  font-size: 0.90rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
.textsRec {
  color: #4a4a4a;
  font-size: 14px;
  line-height: 18px;
}
.theme--light.v-data-table {
  .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #eeeeee !important;
  }
  .v-data-table__wrapper > table > tbody > tr.act-crit {
    background: #f5f5f5 !important;
  }
  .v-data-table__wrapper > table > tbody > tr.act-crit td:nth-child(7) {
    background: rgba(207, 212, 3, .10) !important;
  }
  .v-data-table__wrapper > table > tbody > tr.critica td:nth-child(7) {
    background: rgba(207, 212, 3, .10) !important;
  }
  .v-data-table__wrapper > table > tbody > tr.act-crit-erro {
    background: rgba(255, 68, 0, 0.1) !important;
  }
  .v-data-table__wrapper > table > tbody > tr.act-crit-erro td:nth-child(7) {
    background: rgba(207, 212, 3, .10) !important;
  }
  .v-data-table__wrapper > table > tbody > tr.erro-cadastro {
    background: rgba(255, 68, 0, 0.1) !important;
  }
}
.protocoloDataTable {
    .v-data-table__wrapper > table > tbody> tr > td .theme--light.v-input input {
        font-size: 0.875rem
    }
    .v-data-table__wrapper > table > tbody > tr td:nth-child(4), 
    .v-data-table__wrapper > table > tbody > tr td:nth-child(5),
    .v-data-table__wrapper > table > tbody > tr td:nth-child(6) {
        background-color: rgba(207, 212, 3, .10) !important;
    }
    .v-data-table__wrapper > table > tbody > tr td:nth-child(1) {
        max-width: 300px !important;
    }
    .v-data-table__wrapper > table > tbody > tr td:nth-child(4) {
        min-width: 140px !important;
        max-width: 140px !important;
    }
    .v-data-table__wrapper > table > tbody > tr td:nth-child(6) {
        max-width: 140px !important;
    }
    .v-data-table__wrapper > table > tbody > tr td:nth-child(5) {
        max-width: 140px !important;
        min-width: 140px !important;
    }
    .v-data-table__wrapper > table > tbody > tr td:nth-child(7) {
        min-width: 180px !important;
    }
    .v-data-table__wrapper > table > tbody > tr td:nth-child(8) {
        padding: 0 1px !important;
        min-width: 70px !important;
        max-width: 70px !important;
        text-align: center !important;
    }
}
</style>